import axios from "axios";
const baseUrl = "c-user";

export default {
  saveNotify(data) {
    return axios.post(baseUrl + `/notify`, data);
  },
  detail(data) {
    return axios.post(baseUrl + `/user-info`, data);
  },
  updatedAvatar(data){
    return axios.post(baseUrl + `/update-avatar`, data);
  },
  updatedUser(data){
    return axios.post(baseUrl + `/update-user`, data);
  }
};
